import React, { Component, PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import combineStyles from '../../../helpers/combineStyles';
import LayoutStyles from '../../../styles/layout';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import SpacingStyles from '../../../styles/helpers/spacing';
import ListsStyle from '../__styles__/Lists.style';
import classnames from 'classnames';
import { Formik } from 'formik';
import { Grid } from '@material-ui/core';
import GridItem from '../../shared/GridItem';
import OutlinedTextField from '../../shared/Fields/OutlinedTextField';
import CheckboxInput from '../../shared/Inputs/Checkbox';
import Button from '@material-ui/core/Button';
import ProgressButton from '../../shared/Buttons/ProgressButton';
import ActivityIndicator from '../../shared/ActivityIndicator';
import { history } from '../../../helpers/history';

export class RolesCreateEdit extends PureComponent {
  state = {
    isNew: undefined,
    role: {}
  };

  async componentDidMount() {
    this.setState({
      isNew: !this.props.match.params.id
    });

    if (this.props.match.params.id) {
      const role = await this.props.fetchRole(this.props.match.params.id);
      this.setState({ role });
    }
  }

  handleOnSave = async role => {
    const { createRole, editRole } = this.props;
    if (this.state.isNew !== undefined && this.state.isNew) {
      await createRole(role);
    } else if (this.state.isNew !== undefined && !this.state.isNew) {
      await editRole(this.props.match.params.id, role);
    } else {
      return;
    }
  };

  render() {
    const {
      classes,
      serverErrors,
      permissions,
      isSubmitting,
      FetchRoleAdminSend
    } = this.props;

    const { isNew, role } = this.state;
    const rolesPermission = role.permissions || [];

    const isEditLoading = !isNew && !role.id;
    if (
      FetchRoleAdminSend ||
      isEditLoading ||
      !permissions.length ||
      isNew === undefined
    ) {
      return <ActivityIndicator />;
    }

    const initialValues = {
      name: role.name || '',
      displayName: role.displayName || '',
      permissionIds: rolesPermission.map(({ id }) => Number(id))
    };

    return (
      <section className={classes.headerRoot}>
        <div className={classes.permission}>
          <h1 className={classnames(classes.headline5)}>
            {this.state.isNew ? 'Crear' : 'Editar' + ' Roles'}
          </h1>
        </div>

        <div className={classes.permission}>
          <Formik
            enableReinitialize={false}
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={
              this.state.isNew
                ? {
                    name: '',
                    displayName: '',
                    permissionIds: []
                  }
                : initialValues
            }
            onSubmit={this.handleOnSave}
            onReset={(values, actions) => {
              actions.resetForm();
              history.replace(`/roles`);
            }}
            render={({
              values,
              touched,
              errors,
              handleChange,
              handleSubmit,
              handleReset,
              dirty
            }) => (
              <Grid container spacing={16}>
                <GridItem xs={6}>
                  <OutlinedTextField
                    name="name"
                    onChange={handleChange}
                    className={classes.formControl}
                    value={values.name}
                    label={'Nombre'}
                    disabled={!this.state.isNew}
                    fullWidth
                    error={
                      (touched.name && !!errors.name) ||
                      (serverErrors && !!serverErrors.name)
                    }
                    helperText={
                      (touched.name && errors.name) ||
                      (serverErrors && serverErrors.name && serverErrors.name)
                    }
                  />
                </GridItem>
                <GridItem xs={6}>
                  <OutlinedTextField
                    name="displayName"
                    onChange={handleChange}
                    className={classes.formControl}
                    value={values.displayName}
                    label={'Nombre de visualización'}
                    fullWidth
                    error={
                      (touched.displayName && !!errors.displayName) ||
                      (serverErrors && !!serverErrors.displayName)
                    }
                    helperText={
                      (touched.displayName && errors.displayName) ||
                      (serverErrors &&
                        serverErrors.displayName &&
                        serverErrors.displayName)
                    }
                  />
                </GridItem>

                <GridItem xs={12}>
                  <h4 className={classes.rolesTitle}>Permisos</h4>
                  <div className={classes.rolesContainer}>
                    {permissions.map((permission, index) => (
                      <div key={permission.id} className={classes.roleItem}>
                        <span className={classes.roleIndex}>{index + 1}.</span>
                        <CheckboxInput
                          classes={{
                            root: classnames(
                              classes.noMarginTop,
                              classes.checkboxContainer
                            )
                          }}
                          name="permissionIds"
                          value={values.permissionIds.includes(+permission.id)}
                          label={permission.description}
                          onChange={e => {
                            const { value } = e.target;
                            const newPermissions = value
                              ? [...values.permissionIds, +permission.id]
                              : values.permissionIds.filter(
                                  r => r !== +permission.id
                                );

                            handleChange({
                              target: {
                                name: 'permissionIds',
                                value: newPermissions
                              }
                            });
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </GridItem>

                <GridItem xs={12}>
                  <div className={classes.buttonsContainer}>
                    <Button
                      className={classes.button}
                      onClick={handleReset}
                      color={'secondary'}
                      classes={{ label: classes.buttonLabel }}
                    >
                      {'Regresar'}
                    </Button>
                    <ProgressButton
                      onClick={handleSubmit}
                      className={classes.button}
                      classes={{
                        disabled: classes.buttonDisabled,
                        label: classes.buttonLabel
                      }}
                      color={'secondary'}
                      variant="contained"
                      disabled={!dirty || isSubmitting}
                      isSubmitting={isSubmitting}
                    >
                      {this.state.isNew ? 'Crear Rol' : 'Actualizar Rol'}
                    </ProgressButton>
                  </div>
                </GridItem>
              </Grid>
            )}
          />
        </div>
      </section>
    );
  }
}

const styles = theme => ({
  headerRoot: {
    backgroundColor: '#FFFFFF',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    width: '100%'
  },
  permission: {
    alignItems: 'center',
    display: 'flex',
    minHeight: 84,
    flexWrap: 'wrap',
    padding: [[0, theme.spacing.unit * 3]],
    position: 'relative',
    '&:first-child': {
      borderBottom: '1px solid rgba(12,31,44,0.12)'
    }
  },
  backButton: {
    position: 'absolute',
    left: 16
  },
  error: {
    backgroundColor: '#FDE5E2',
    color: ['#F22D12', '!important']
  },
  root: {
    backgroundColor: '#FFF',
    borderRadius: '2px',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    padding: theme.spacing.unit * 4,
    width: '100%',
    marginBottom: '10px'
  },
  headerSection: {
    flex: 1,
    paddingBottom: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 4,
    borderBottom: '1px solid rgba(0,0,0,0.12)'
  },
  bodySection: {
    display: 'flex',
    flex: 1
  },
  rolesTitle: {
    marginBottom: '8px',
    color: '#333'
  },
  rolesContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  roleItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    height: '40px'
  },
  roleIndex: {
    fontSize: '0.85rem',
    fontWeight: 'bold',
    color: '#555',
    marginRight: '6px',
    width: '20px'
  },
  buttonsContainer: {
    display: 'flex'
  }
});

export default withStyles(
  combineStyles(
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    ListsStyle,
    styles
  )
)(RolesCreateEdit);
